export default __webpack_public_path__ + "img/1.92737adc.jpg";